import { $sxhr } from "../../stempcore";
import { staticRequest } from "../service";

export default {
  //获取登录注册的地址
  getRegistrationForm: info => {
    return $sxhr.post("member/form/GetForNewForm", info);
  },
  getCustomForm: info => {
    return $sxhr.post("api/customform/get", info);
  },
  checkRegistration: info => {
    return $sxhr.post("webinar/open/checkRegistration", info);
  },
  silentSignUp: info => {
    return $sxhr.post("api/webinar/contacts/signup", info);
  },
  logoutWeChat: info => {
    return $sxhr.post("member/member/associate/Logout", info);
  },
  //记录浏览行为
  activeRecords: info => {
    return $sxhr.post("api/webinar/live/site/browse", info);
  },
  //用户开始播放的记录。用户Play
  logPlayStart: info => {
    return $sxhr.post("api/webinar/user/userJoin", info);
  },
  //用户停止播放的记录。用户Stop
  logPlayStop: info => {
    return $sxhr.post("api/webinar/user/userLeave", info);
  },
  //获取保利威频道签名
  getSign: info => {
    return $sxhr.post("api/webinar/getSign", info);
  },
  //获取tc wap短链接
  getTcShortUrl: info => {
    return $sxhr.post("api/webinar/channel/GetUrlByTC", info);
  }
};
